<template>
  <v-layout class="overlay-photos">
    <v-flex xs12 center @click.self="close">
      <v-flex md8 xs10 offset-xs1 offset-md2 center class="inner-container">
        <v-layout wrap class="images-container">
          <v-flex
            v-for="photo in overlayPhotos"
            :key="photo.id"
            xs6
            md4
            class="image-container"
          >
            <div
              v-if="!photo.attributes.video"
              class="image"
              :style="{
                'background-image': `url(${cdnUrl(photo.attributes.image)})`,
              }"
              @click="setOverlayPhoto(photo)"
            />
            <video
              v-else
              preload="auto"
              controls="true"
              :poster="cdnUrl(photo.attributes.video_thumb)"
              class="image"
            >
              <source
                :src="cdnUrl(photo.attributes.video_url)"
                type="video/mp4"
              />
            </video>
            <div class="caption-text">
              {{ photo.attributes.caption || '&nbsp;' }}
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import { replaceWithCdnUrl } from '@/utils/cdnHelper'

export default {
  computed: {
    ...mapState('reports', ['overlayPhotos']),
  },
  methods: {
    cdnUrl(url) {
      return replaceWithCdnUrl(url) || url
    },
    close() {
      this.$store.commit('reports/setValue', {
        key: 'overlayPhotos',
        value: [],
      })
    },
    setOverlayPhoto(photo) {
      this.$store.commit('reports/setValue', {
        key: 'overlayPhoto',
        value: photo,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.overlay-photos {
  z-index: 2;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.75);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;

  > .flex {
    display: flex;
    align-items: center;
  }
}

.inner-container {
  cursor: default;
  height: 90%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 2em;
  background-color: #555;
}

.images-container {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  align-items: flex-start;
  align-content: flex-start;

  .image-container {
    width: 100%;
    height: auto;
    padding: 2em;
  }

  .image {
    height: 15em;
    width: 100%;
    background-size: contain;
    background-position: center;
    transition: opacity 0.1s linear;

    &:hover {
      cursor: zoom-in;
      opacity: 0.8;
    }
  }
}

.caption-text {
  color: #fff;
  padding: 0.5em 1em;
}

@media (max-width: 960px) {
  .images-container .image-container {
    padding: 0.25em;
  }
  .images-container .image {
    min-height: 10em;
  }
}
</style>
